import {isFalse, isTrue} from "@/utils/service/DocumentGeneration/answers";

export default [
    {
        name: "Contact Information",
        inputs: [
            {
                model: "company.name",
                type: "businessName",
                classes: "col-md-6",
            },
            {
                model: "company.email",
                type: "email",
                classes: "col-md-6",
            },
            {
                model: "website_url",
                type: "websiteUrl",
                classes: "col-md-6",
            },
        ],
        actions: [
            {
                component: () => import("@/components/Projects/Project/ProjectGeneralInformationUpdateOnDocumentCreate.vue"),
                params: (self) => ({
                    color: "secondaryDark",
                    text: true,
                    class: "th-mr-12",
                    to: {
                        name: "project_index",
                        params: self?.$route.params,
                    },
                }),
                cta: "Edit project information",
            },
        ]
    },
    {
        name: "Preferences",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: (self) => ({
                    title: "Preferences cookies",
                    subtitle: "Preferences cookies are used to improve the functional performance of your website and make it easier to use. These cookies enable your website to remember the settings selected by the visitors (for example, the settings of language or currency). With the use of these cookies, the visitor may avoid the changes of settings during each visit to your website. These cookies also remember changes made by your user on the website (for example, in case the user leaves a comment on the website). These cookies do not track user's behavior on other websites."
                }),
            },
        ],
        inputs: [
            {
                title:
                    "Do you use cookies to recognize the returning visitor of the website and analyze your user's habits?",
                model: "cookie_purpose.recognize_returning_users_and_analyze",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ],
    },
    {
        name: "Analytics and Statistics",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: (self) => ({
                    title:
                        "Analytics and Statistics cookie",
                    subtitle: "Analytics and Statistics cookies show if the user has visited your website before. The analytic cookies allow you to recognize and count the number of users of your website and see how such users navigate through your website. These cookies are used to understand, improve, and research products, features, and services. For instance, analytical cookies may show you, which websites are visited more frequently, help you to record dysfunctionalities of the website, etc.",
                }),
            },
        ],
        inputs: [
            {
                title: "Do you use cookies to analyze your users' habits and to measure the flows of the information and data being sent to your website?",
                model: "cookie_purpose.analyze_habits_and_measure",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ],
    },
    {
        name: "Targeting and Advertising",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: (self) => ({
                    title:
                        "Targeting and Advertising cookies",
                    subtitle: "By using Targeting and Advertising cookies you may collect information so that only relevant content would be displayed for the browser by creating different target groups. You may use these cookies to show user-relevant advertising both on and off your website.",
                }),
            },
        ],
        inputs: [
            {
                title: "Do you use cookies for targeting and advertising?",
                model: "cookie_purpose.targeting",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ],
    },
    {
        name: "Third Party",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: (self) => ({
                    title:
                        "Targeting and Advertising cookies",
                    subtitle: "Third-party cookies are cookies that are set by other websites. For example, if you have a Facebook \"Like\" button on your website or advertisements with links to the other company's website.",
                }),
            },
        ],
        inputs: [
            {
                title: "Does you use third-party cookies?",
                model: "used_third_party_cookies.use",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                }
            },
            {
                condition: (model) =>
                    isTrue(model["used_third_party_cookies.use"]),
                title:
                    "Does your website contains third party advertising cookies?",
                model: "used_third_party_cookies.advertising",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
            {
                condition: (model) =>
                    isTrue(model["used_third_party_cookies.use"]),
                title:
                    "Does your website contain other parties (for example social networks) cookies?",
                model: "used_third_party_cookies.other",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            }
        ],
    },
    {
        name: "Google Analytics",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: (self) => ({
                    title:
                        "Google Analytics",
                    subtitle: "Google Analytics is a tracking tool offered by Google LLC. It shows you how visitors use your website and allows you to track and understand your customer's behavior and user experience.",
                }),
            },
        ],
        inputs: [
            {
                title: "Do you use Google Analytics?",
                model: "used_third_party_cookies.google_analytics",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ],
    },
    {
        name: "Cookies List",
        inputs: [
            {
                component: () =>
                    import("@/components/Documents/CookiePolicy/CookieList.vue"),
                model: "cookie_list",
                type: "custom",
            },
        ],
    },
    {
        name: "Cookie Consent Banner",
        inputs: [
            {
                title: "Do you use Cookie Consent Banner?",
                model: "cookie_notice_shown",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
            {
                condition: (model) => isFalse(model["cookie_notice_shown"]),
                model: "cookie_notice_use_termshub",
                default: "false",
                type: "projectCookieConsentCreateSuggest",
            },
        ],
    },
];
